<template>
  <el-main>
    <iao-guides />
  </el-main>
</template>

<script>
  // components
  import IaoGuides from './iaoGuides/IaoGuides';

  export default {
    name: 'PageContent',
    components: {
      IaoGuides
    },
  }
</script>
